import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { countVehiclesInspectedDailyService } from "../services/countVehiclesInspectedDaily.service.js";
import debounce from "lodash.debounce";

export const useCountVehiclesInspectedDailyQuery = (filters) => {
  const fetchData = useFetch();
  const [countVehiclesInspectedDaily, setCountVehiclesInspectedDaily] =
    useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchVehiclesInspected = async () => {
      try {
        setLoading(true);
        const response = await countVehiclesInspectedDailyService(fetchData)({
          filters,
        });
        setCountVehiclesInspectedDaily(response.vehiclesInspectedDaily);
      } catch (error) {
        console.error("Error fetching vehicles inspected:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchVehiclesInspected, 300);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters?.startDate, filters?.endDate]);

  return {
    countVehiclesInspectedDaily,
    loading,
    refresh: () => setRefresh((prev) => !prev),
  };
};
